import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { LanguageProvider, useLang } from "@/i18n";
import LanguageModal from "@/components/LanguageModal";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeSection from "@/components/MarqueeSection";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";

function MarketingSite() {
  const { lang, setLang } = useLang();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <AnimatePresence>
        {!lang && <LanguageModal onSelect={setLang} />}
      </AnimatePresence>
      <Navbar />
      <main>
        <Hero />
        <MarqueeSection />
        <Services />
        <Portfolio />
        <Manifesto />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App grain relative bg-background text-foreground min-h-screen" data-testid="app-root">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#fff",
          },
        }}
      />
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MarketingSite />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
